<template>
  <div class="about" :style="{ backgroundColor: color }" :class="[color==='#ffffff' ? 'whild' : '']">
    <span>{{ nowDate }}</span>
    <img v-for="item in iconListsmall" v-if="color!=='#ffffff' && nationId !== 'cn'"
         @click="openLink(item.link)" :src="item.url" alt="">
    <span @click="changeType(1)" v-if="!noAbout">{{ $t('con_about') }}</span>
  </div>
</template>
<script>

import {format} from "date-fns";

export default {
  props: {
    template: {
      type: String,
    },
    nationId: {
      type: String,
    },
    noAbout: {
      type: String,
    },
    color: {
      type: String,
    }
  },
  name: "index",
  data() {
    return {
      nowDate: undefined,
      iconListsmall: [
        {url: require('../../assets/icon/linkedin.png'), link: 'https://www.linkedin.cn/'},
        {url: require('../../assets/icon/facebook.png'), link: 'https://www.facebook.com/'},
        {url: require('../../assets/icon/flipboard.png'), link: 'https://www.flipboard.cn/'},
        {url: require('../../assets/icon/twitter.png'), link: 'https://twitter.com/'},
        {url: require('../../assets/icon/instagram.png'), link: 'https://www.instagram.com/'},
      ],
    }
  },
  methods: {
    openLink(link) {
      window.open(link)
    },
    changeType() {
      location.reload();
    }
  },
  created() {
    this.nowDate = format(new Date(), this.$t('con_format'))
  },
}

</script>
<style scoped lang="scss">
.about {
  cursor: pointer;
  height: 40px;
  line-height: 40px;
  font-weight: 400;
  font-size: 15px !important;
  text-transform: uppercase;
  display: flex;
  justify-content: end;
  //justify-content: space-between;
  padding-right: 20px;
  color: #ffffff;
  align-items: center;

  span {
    margin-left: 20px;
    margin-right: 20px;
  }

  img {
    width: 20px;
    height: 20px;
  }

  img:nth-child(4) {
    width: 30px;
    height: 30px;
  }
  img:nth-child(5) {
    width: 30px;
    height: 30px;
  }
  img:nth-child(6) {
    width: 30px;
    height: 30px;
  }
}

.whild {
  color: red !important;
}
</style>